module.exports = __webpack_public_path__ + "img/SINGLE_ROLE_A1010.531686f1.png";